"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Group = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _chipsPopup = _interopRequireDefault(require("./chipsPopup"));

var _Sizer = _interopRequireDefault(require("../Sizer/Sizer"));

var _reactVirtualizedAutoSizer = _interopRequireDefault(require("react-virtualized-auto-sizer"));

var _popupStateful = _interopRequireDefault(require("../Popup/popupStateful"));

var _lodash = _interopRequireDefault(require("lodash.isequal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Group =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Group, _React$Component);

  function Group() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, Group);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Group)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_this), "remainingChips", function (nrHiddenElements) {
      return _react.default.createElement(_chipsPopup.default, {
        position: _this.props.popupPosition,
        remainingChipsCount: nrHiddenElements,
        remainderElementSize: _this.props.remainderElementSize,
        popupHeaderTitle: _this.props.popupHeaderTitle
      }, _this.props.children);
    });

    return _this;
  }

  _createClass(Group, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return !(0, _lodash.default)(nextProps, this.props);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          width = _this$props.width,
          getBoundingClientRect = _this$props.getBoundingClientRect,
          useLoadingPlaceholder = _this$props.useLoadingPlaceholder;
      return children ? _react.default.createElement(_Sizer.default, {
        width: width,
        getBoundingClientRect: getBoundingClientRect,
        remainderElement: this.remainingChips,
        useLoadingPlaceholder: useLoadingPlaceholder
      }, children) : null;
    }
  }]);

  return Group;
}(_react.default.Component);

exports.Group = Group;

function ChipsGroup(props) {
  return _react.default.createElement(_reactVirtualizedAutoSizer.default, {
    disableHeight: true
  }, function (_ref) {
    var width = _ref.width;
    return _react.default.createElement(Group, _extends({}, props, {
      width: width
    }));
  });
}

ChipsGroup.defaultProps = {
  remainderElementSize: 'medium',
  useLoadingPlaceholder: true
};
ChipsGroup.propTypes = {
  /** {---} Sequence of: @@<Chip>@@ */
  children: _propTypes.any,

  /** {const} One of: @@ChipsGroup.POPUP_LEFT_TOP@@ @@ChipsGroup.POPUP_CENTER_TOP@@ @@ChipsGroup.POPUP_RIGHT_TOP@@ @@ChipsGroup.POPUP_LEFT_CENTER@@ @@ChipsGroup.POPUP_RIGHT_CENTER@@ @@ChipsGroup.POPUP_LEFT_BOTTOM@@ @@ChipsGroup.POPUP_CENTER_BOTTOM@@ @@ChipsGroup.POPUP_RIGHT_BOTTOM@@ */
  popupPosition: _popupStateful.default.propTypes.position,

  /** {func, string} */
  popupHeaderTitle: (0, _propTypes.oneOfType)([_propTypes.func, _propTypes.string]),

  /** {string} One of: @@'small'@@ @@'medium'@@ @@'large'@@ */
  remainderElementSize: (0, _propTypes.oneOf)(['small', 'medium', 'large']),
  useLoadingPlaceholder: _propTypes.bool
};
ChipsGroup.POPUP_LEFT_TOP = _popupStateful.default.POSITION_LEFT_TOP;
ChipsGroup.POPUP_CENTER_TOP = _popupStateful.default.POSITION_CENTER_TOP;
ChipsGroup.POPUP_RIGHT_TOP = _popupStateful.default.POSITION_RIGHT_TOP;
ChipsGroup.POPUP_LEFT_CENTER = _popupStateful.default.POSITION_LEFT_CENTER;
ChipsGroup.POPUP_RIGHT_CENTER = _popupStateful.default.POSITION_RIGHT_CENTER;
ChipsGroup.POPUP_LEFT_BOTTOM = _popupStateful.default.POSITION_LEFT_BOTTOM;
ChipsGroup.POPUP_CENTER_BOTTOM = _popupStateful.default.POSITION_CENTER_BOTTOM;
ChipsGroup.POPUP_RIGHT_BOTTOM = _popupStateful.default.POSITION_RIGHT_BOTTOM;
var _default = ChipsGroup;
exports.default = _default;
Group.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "remainingChips",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "nrHiddenElements",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "Group"
};
ChipsGroup.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "ChipsGroup",
  "props": {
    "remainderElementSize": {
      "defaultValue": {
        "value": "'medium'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'small'",
          "computed": false
        }, {
          "value": "'medium'",
          "computed": false
        }, {
          "value": "'large'",
          "computed": false
        }]
      },
      "required": false,
      "description": "{string} One of: @@'small'@@ @@'medium'@@ @@'large'@@"
    },
    "useLoadingPlaceholder": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "children": {
      "type": {
        "name": "any"
      },
      "required": false,
      "description": "{---} Sequence of: @@<Chip>@@"
    },
    "popupPosition": {
      "type": {
        "name": "custom",
        "raw": "PopupStateful.propTypes.position"
      },
      "required": false,
      "description": "{const} One of: @@ChipsGroup.POPUP_LEFT_TOP@@ @@ChipsGroup.POPUP_CENTER_TOP@@ @@ChipsGroup.POPUP_RIGHT_TOP@@ @@ChipsGroup.POPUP_LEFT_CENTER@@ @@ChipsGroup.POPUP_RIGHT_CENTER@@ @@ChipsGroup.POPUP_LEFT_BOTTOM@@ @@ChipsGroup.POPUP_CENTER_BOTTOM@@ @@ChipsGroup.POPUP_RIGHT_BOTTOM@@"
    },
    "popupHeaderTitle": {
      "type": {
        "name": "union",
        "value": [{
          "name": "func"
        }, {
          "name": "string"
        }]
      },
      "required": false,
      "description": "{func, string}"
    }
  }
};